import {validation, DateArray} from '@rambler-id/input'
import {translate} from 'utils/translate'
import domains from 'components/LoginField/domains'

const getValidationMessage =
  (validate) =>
  (value = '') => {
    const result = validate(value)

    if (result) {
      const [key, ...values] = Array.isArray(result) ? result : [result]

      return translate(key, ...values)
    }
  }

export const fieldEmpty = getValidationMessage(validation.fieldEmpty)
export const fieldInvalid = getValidationMessage(validation.fieldInvalid)
export const emailEmpty = getValidationMessage(validation.emailEmpty)
export const emailInvalid = getValidationMessage(validation.emailInvalid)
export const passwordEmpty = getValidationMessage(validation.passwordEmpty)
export const passwordInvalid = getValidationMessage(validation.passwordInvalid)
export const passwordChars = getValidationMessage(validation.passwordChars)
export const dateEmpty = getValidationMessage(validation.dateEmpty)
export const genderEmpty = getValidationMessage(validation.genderEmpty)
export const geoEmpty = getValidationMessage(validation.geoEmpty)
export const reCaptchaEmpty = getValidationMessage(validation.reCaptchaEmpty)
export const captchaEmpty = getValidationMessage(validation.captchaEmpty)
export const questionInvalid = getValidationMessage(validation.questionInvalid)
export const answerInvalid = getValidationMessage(validation.answerInvalid)
export const phoneEmpty = getValidationMessage(validation.phoneEmpty)
export const phoneInvalid = getValidationMessage(validation.phoneInvalid)
export const phoneUnavailableForCalls = getValidationMessage(
  validation.phoneUnavailableForCalls
)
export const smsCodeEmpty = getValidationMessage(validation.smsCodeEmpty)

export const smsCodeEmptyShort = (value = ''): string | void => {
  const key = validation.smsCodeEmpty(value, 4)

  if (key) {
    return translate(key)
  }
}

export const passwordMatch = (
  password: string,
  {newPassword}: {newPassword: string}
): string | void => {
  const key = validation.passwordMatch(password, newPassword)

  if (key) {
    return translate(key)
  }
}

export const passwordConfirm = (
  password: string,
  {newPassword}: {newPassword: string}
): string | void => {
  const key = validation.passwordConfirm(password, newPassword)

  if (key) {
    return translate(key)
  }
}

export const dateInvalid = (
  date: DateArray,
  _: Record<string, any>,
  props: {config?: {age?: number}}
): string | void => {
  const key = validation.dateInvalid(date, props?.config?.age)

  if (key) {
    return translate(Array.isArray(key) ? key[0] : key)
  }
}

interface Order {
  fetching?: boolean
  orderId?: string
}

export const smsCodeSent = (order: Order): string | undefined => {
  if (order && (order.fetching || !!order.orderId)) {
    return
  }

  return translate('sms_code_not_sent')
}

export const scrollToError = (): void => {
  const scrollTarget = document.querySelector('.rui-InputStatus-error')

  if (scrollTarget) {
    const scrollCoords = scrollTarget.getBoundingClientRect()

    try {
      window.scrollTo({
        left: 0,
        top: scrollCoords.y + window.pageYOffset - 50,
        behavior: 'smooth'
      })
    } catch (error) {
      window.scrollTo(0, scrollCoords.y + window.pageYOffset - 50)
    }
  }
}

export const notRamblerMail = (email = ''): string | undefined => {
  const isNotAllowedDomainExists = domains.some((domain) =>
    email.endsWith(domain)
  )

  return isNotAllowedDomainExists ? translate('mail_not_allowed') : undefined
}
